import React from 'react';

import component, {classnames} from './component';
import settings from '../settings';

export default component('YandexMetrika', function() {
  if (!settings.enableYandex()) {
    return <div/>;
  }

  let content = `
      <!-- Yandex.Metrika counter -->
      <script type="text/javascript">
        (function (d, w, c) {
        (w[c] = w[c] || []).push(function() {
          try {
            w.yaCounter30837481 = new Ya.Metrika({id:30837481,
              webvisor:true,
              clickmap:true,
              trackLinks:true,
              accurateTrackBounce:true});
          } catch(e) { }
        });
        var n = d.getElementsByTagName("script")[0],
        s = d.createElement("script"),
        f = function () { n.parentNode.insertBefore(s, n); };
        s.type = "text/javascript";
        s.async = true;
        s.src = (d.location.protocol == "https:" ? "https:" : "http:") + "//mc.yandex.ru/metrika/watch.js";
        if (w.opera == "[object Opera]") {
        d.addEventListener("DOMContentLoaded", f, false);
      } else { f(); }
      })(document, window, "yandex_metrika_callbacks");
      </script>
      <noscript><div><img src="//mc.yandex.ru/watch/30837481" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
      <!-- /Yandex.Metrika counter -->`;
  
  return <div dangerouslySetInnerHTML={{__html:content}}></div>;
});




// WEBPACK FOOTER //
// ./src/components/YandexMetrika.js